import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageKeys, StorageService } from '../services/storage.service';
import { Facility } from '../types/facility';
import { EnterpriseStore } from './enterprise.store';
import { UserRoleStore } from './user-role.store';

@Injectable({
  providedIn: 'root',
})
export class FacilityStore {
  private currentFacilityId: string | null = this.storageService.getItem(StorageKeys.CURRENT_FACILITY_ID);
  private currentFacilitySubj$: BehaviorSubject<Facility> = new BehaviorSubject<Facility>(null!);

  currentFacility$ = this.currentFacilitySubj$.asObservable();

  constructor(
    private storageService: StorageService,
    private userRoleStore: UserRoleStore,
    private enterpriseStore: EnterpriseStore,
  ) {}

  setCurrentFacility(facility: Facility | null): void {
    if (!facility) {
      this.currentFacilityId = null;
      this.storageService.removeItem(StorageKeys.CURRENT_FACILITY_ID);
      this.currentFacilitySubj$.next(null!);
      return;
    }

    this.currentFacilityId = facility.id;
    this.storageService.setItem(StorageKeys.CURRENT_FACILITY_ID, facility.id);

    this.userRoleStore.setCurrentFacilityId(this.currentFacilityId);

    if (facility.enterprise) {
      this.enterpriseStore.setCurrentEnterprise(facility.enterprise);
    } else if (facility.enterpriseId) {
      const enterprise = this.enterpriseStore.getEnterpriseById(facility.enterpriseId);
      if (enterprise) {
        this.enterpriseStore.setCurrentEnterprise(enterprise);
        facility.enterprise = enterprise;
      }
    }

    this.currentFacilitySubj$.next(facility);
  }

  getCurrentFacility(): Facility {
    return this.currentFacilitySubj$.value;
  }

  getCurrentFacilityId(): string | null {
    return this.currentFacilityId;
  }

  clear(): void {
    this.storageService.removeItem(StorageKeys.CURRENT_FACILITY_ID);
    this.currentFacilitySubj$.next(null!);
  }

  facilityRenamed(facilityId: string, facilityName: string) {
    let currentFacility = this.getCurrentFacility();
    if (currentFacility?.id === facilityId) {
      currentFacility.name = facilityName;
    }
  }

  facilityRemoved(facilityId: string) {
    if (this.currentFacilityId === facilityId) {
      this.clear();
    }
  }
}
